import React from 'react';

export default function ListImage(props) {
  return (
    <div className="relative">
      <img src={props.src} alt="" className="border rounded-[10px]" />
      <div className="absolute bottom-4 left-8">
        <p className="text-secondary lg:text-2xl sm:text-xl text-base font-medium">{props.title}</p>
        <p className="text-secondary  lg:text-base sm:text-sm text-xs">{props.address}</p>
      </div>
    </div>
  );
}
